export const SLEEPING = "SLEEPING";
export const SAVING = "SAVING";
export const DELETING = "DELETING";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
